import { provideAppInitializer, inject, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withDisabledInitialNavigation } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import {
    MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService,
    MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, ProtectedResourceScopes
} from '@azure/msal-angular';
// import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// Register AG Grid Community modules once for the whole application
// ModuleRegistry.registerModules([AllCommunityModule]);

import { msalConfig, loginRequest, protectedResources } from './auth-config';
import { routes, initialNavigation } from './app.routes';
import { UtilService } from './common-services/util.service';
import { AuthService } from './auth.service';
import { RoleGuard } from './role.guard';

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string | ProtectedResourceScopes> | null>();
    protectedResourceMap.set(protectedResources.itemsEndpoint.endpoint, [...protectedResources.itemsEndpoint.scopes]);
    protectedResourceMap.set(protectedResources.itemsEndpointV2.endpoint, [...protectedResources.itemsEndpointV2.scopes]);
    protectedResourceMap.set(protectedResources.itemsEndpointV3.endpoint, [...protectedResources.itemsEndpointV3.scopes]);
    return {
        interactionType: InteractionType.Popup,
        protectedResourceMap,
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: loginRequest
    };
}


export const appConfig: ApplicationConfig = {
    providers: [
        provideAppInitializer(() => {
            const msalService = inject(MsalService);
            return msalService.instance.initialize();
        }),
        provideZoneChangeDetection(),
        initialNavigation
            ? provideRouter(routes)
            : provideRouter(routes, withDisabledInitialNavigation()),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        importProvidersFrom(MsalModule),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalBroadcastService,
        RoleGuard,
        UtilService,
        AuthService,
    ]
};
